export const getInitialState = (): any => ({
  uploadStatusData: {}
});
